import { Quote } from '../models/quote.model';
import { cleanMoneyString } from './format.util';

const MONEY_FIELDS = [
  'basePrice',
  'tradeInValue',
  'docFees',
  'extendedWarranties',
  'addOns',
  'protectionPackages',
  'dealerInventoryTaxes',
  'deliveryFees',
  'taxesPaidDealerState',
  'dealerServiceFee',
  'taxCreditAmount',
] as const;

/** Strips "$", commas and whitespace from money fields and trims the VIN so stored values parse as plain numbers. */
export function normalizeQuoteValues(values: Partial<Quote>): Partial<Quote> {
  const normalized: Record<string, unknown> = { ...values };
  MONEY_FIELDS.forEach((field) => {
    const value = normalized[field];
    if (typeof value === 'string') normalized[field] = cleanMoneyString(value);
  });
  if (typeof normalized.vinNumber === 'string') normalized.vinNumber = normalized.vinNumber.trim();
  return normalized as Partial<Quote>;
}
